import axios from "axios";

// 1 FE untuk beberapa BE: arahkan ke service piket bila diisi,
// fallback ke BE utama bila masih monolit.
const API = axios.create({
  baseURL: process.env.REACT_APP_API_PIKET || process.env.REACT_APP_API_MASTER,
  headers: {
    "Content-Type": "application/json"
  }
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

class PiketService {
  getRegu() {
    return API.get("/regu");
  }
  createRegu(payload) {
    return API.post("/regu", payload);
  }
  getJadwal(params = {}) {
    const q = new URLSearchParams(params).toString();
    return API.get(`/jadwal${q ? `?${q}` : ""}`);
  }
  getJadwalHariIni() {
    const today = new Date().toISOString().slice(0, 10);
    return API.get(`/jadwal?tanggal=${today}`);
  }
  createJadwal(payload) {
    return API.post("/jadwal", payload);
  }
  getTukar(status) {
    return API.get(`/tukar${status ? `?status=${status}` : ""}`);
  }
  ajukanTukar(payload) {
    return API.post("/tukar", payload);
  }
  approveTukar(id, status) {
    return API.put(`/tukar/${id}`, { status });
  }
}

export default new PiketService();
